import axios from "axios";
import { addMessage } from "./messages.js";

function addListName(list) {
  let title = document.createElement("span");
  title.innerText = list.title;
  if (list.permissions["owner"]) {
    return title;
  } else {
    let wrapper = document.createDocumentFragment();
    title.innerText = `${list.title} (`;
    let icon = document.createElement("i");
    icon.classList.add("fas", "fa-share-nodes", "mx-2");
    let owner = document.createElement("span");
    owner.innerText = `${list.ownerName} )`;
    wrapper.append(title, icon, owner);
    return wrapper;
  }
}

function buildTargetList(modal, action) {
  axios
    .get(`/api/reference-lists/get-by-record/${modal.recordId}`)
    .then(function (result) {
      result.data.forEach(function (targetList) {
        const link = document.createElement("a");
        link.classList.add("button", "is-fullwidth");
        if (targetList.permissions["add"] === false) return;
        if (targetList.entryInserted) {
          // add Disabled List Button
          link.setAttribute("disabled", "");
          const tickSpan = document.createElement("span");
          tickSpan.classList.add("icon");
          const tick = document.createElement("i");
          tick.classList.add("fas", "fa-check");
          tickSpan.appendChild(tick);
          link.appendChild(tickSpan);
        } else {
          const clickHandler = function (ce) {
            ce.preventDefault();

            let api_data = { recordId: modal.recordId };
            if (action === "move") {
              api_data["sourceListId"] = modal.sourceListId;
            }
            axios
              .post(
                `/api/reference-lists/${targetList.id}/${action === "move" ? "move" : "add"}-entry`,
                api_data,
              )
              .then(function (response) {
                if (action === "move") {
                  const box = document.getElementById(modal.recordId);
                  if (box) {
                    box.parentNode.removeChild(box);
                  }
                }
                modal.modal.classList.remove("is-active");
                modal.modal.dispatchEvent(modal.closingEvent);
                addMessage(response.data, "success");
                link.removeEventListener("click", clickHandler, false);
              })
              .catch(function (error) {
                addMessage(error.response.data, "danger");
                console.log(error);
              });
          };
          link.addEventListener("click", clickHandler, false);
        }
        link.appendChild(addListName(targetList));
        modal.buttonList.appendChild(link);
      });
    });
}

export { buildTargetList };
